import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { LoaderService } from "app/shared/components/loader/loader.service";
import { Observable } from "rxjs";

@Component({
  selector: "loader",
  template: `
    @if (isLoading$ | async) {
      <div class="loader">
        <div
          data-e2e="global-fragment__loading-spinner"
          class="loader__spinner"
        >
          <svg height="32" viewBox="0 0 32 32" width="32">
            <circle cx="16" cy="16" fill="none" class="spinner" r="14"></circle>
          </svg>
        </div>
      </div>
    }
  `,
  styleUrls: ["./loader.component.scss"],
  imports: [AsyncPipe, CommonModule],
  standalone: true,
})
export class LoaderComponent implements OnInit {
  isLoading$: Observable<boolean>;
  loaderService = inject(LoaderService);

  constructor() {}

  public ngOnInit(): void {
    this.isLoading$ = this.loaderService.isLoading$;
  }
}
